import { render, staticRenderFns } from "./Ads.vue?vue&type=template&id=4cd889ed"
import script from "./Ads.vue?vue&type=script&setup=true&lang=ts"
export * from "./Ads.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports